<div class="content">
  @if (label) {
  <div class="l-pt-2 l-pb-2 select-lalel" [class.disabled]="disabled">
    <span class="cds-body2">{{ label }}</span>
  </div>
  }
  <div
    class="row l-plr-0 text-field"
    [ngClass]="{
      '': !editMode,
      'text-field-not-input': editMode,
      'text-field-input': _input,
      'text-field-input-disabled': disabled
    }">
    <div class="col-xs l-plr-0">
      @if (editMode || !wrapValue) {
      <input
        [placeholder]="placeholder"
        [disabled]="!editMode || disabled"
        (focus)="cssTrigger(true)"
        (blur)="cssTrigger(false)"
        #inputBox
        (input)="inputVal(inputBox.value, true)"
        [value]="value" />
      } @if (!editMode && wrapValue) {
      <div class="text-field-value">{{ value }}</div>
      }
    </div>
    @if (editMode && !showDropdownButton && value !== '') {
    <div class="pointer middle-xs">
      <cds-icon (click)="inputVal('', true)" width="20px" color="#8E90A2" icon="action:button_x_filled"></cds-icon>
    </div>
    } @if (editMode && showDropdownButton) {
    <div class="pointer middle-xs" [class.disabled]="disabled">
      <cds-icon (click)="toggleSelectPanel()" width="26px" height="26px" [color]="disabled ? '#5e607366' : '#282B3E'" icon="action:button_down"></cds-icon>
    </div>
    }
  </div>
  @if (editMode && _input && inputValid && ((optionList.length > 0) || isLoading) && (initLoad || value !== '')) {
  <div #selectPanelRef (scroll)="selectPanelonScroll()" class="select-panel l-mt-2">
    @if (optionList.length > 0) { @for (item of optionList; track item) {
    <div (mousedown)="inputVal((item ? item[optionKey] : '') || item, false, item)" class="select-option l-pa-2 pointer">
      {{ labelRenderFn ? labelRenderFn(item) : (item ? item[optionKey] : '') || item }}
    </div>
    } } @if (isLoading) {
    <div class="loading">
      <cds-progress mode="indeterminate" type="ring" [diameter]="22">Loading</cds-progress>
    </div>
    }
  </div>
  }
</div>
